import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { DataHubLogRepository } from '../dataHubLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { DataHubLogDetailsGridComponent } from './dataHubLogDetailsGrid.component';

export interface DataHubLogDetailsParams {
    summaryLogId: number;
}

@Component({
    selector: 'data-hub-log-details-modal',
    templateUrl: './dataHubLogDetailsModal.component.html',
    styleUrls: ['./dataHubLogDetailsModal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class DataHubLogDetailsModalComponent implements OnInit, IWeissmanModalComponent<DataHubLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _dataHubLogRepository: DataHubLogRepository) {
    }

    @ViewChild('dataHubLogDetailsGrid') dataHubLogDetailsGrid: DataHubLogDetailsGridComponent;

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: DataHubLogDetailsParams;
    result: void;

    dataHubDiagnosticsDetail: Core.DataHubDiagnosticsDetailModel;

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading Data Hub Log Details', busyMsgId);

        const searchParams: Core.DataHubDiagnosticsDetailSearchModel = {
            summaryLogId: this.params.summaryLogId
        };

        try {
            this.dataHubDiagnosticsDetail = await lastValueFrom(this._dataHubLogRepository.getDetail(searchParams));
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
